import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

// stable color generator
const colorForGroup = (group) => {
  let hash = 0;
  for (let i = 0; i < group.length; i++) {
    hash = group.charCodeAt(i) + ((hash << 5) - hash);
  }
  return `hsl(${Math.abs(hash) % 360}, 65%, 55%)`;
};

const formatMonth = (m) => {
  const [year, month] = m.split("-");
  return new Date(year, month - 1).toLocaleString("en", {
    month: "short",
    year: "numeric",
  });
};

const GroupWiseChart = ({ data = [] }) => {
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div className="h-full flex items-center justify-center text-gray-400 text-sm">
        No data available
      </div>
    );
  }

  const months = [...new Set(data.map(d => d.month))];
  const groups = [...new Set(data.map(d => d.vehicle_group))];

  const datasets = groups.map(group => ({
    label: group,
    data: months.map(month => {
      const row = data.find(
        d => d.month === month && d.vehicle_group === group
      );
      return row ? Number(row.total) : 0;
    }),
    backgroundColor: colorForGroup(group),
    borderRadius: 4,
    barThickness: 24,
  }));

  return (
    <Bar
      data={{
        labels: months.map(formatMonth),
        datasets,
      }}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom",
          },
          tooltip: {
            callbacks: {
              label: (ctx) =>
                `${ctx.dataset.label}: ${ctx.raw}`,
            },
          },
          datalabels: {
            color: "#2c2828ff",
            font: { weight: "600", size: 11 },
            formatter: (value) => {
              // 🔥 HIDE ZERO VALUES
              if (value === 0) return "";
              return value;
            },
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: { precision: 0 },
            grid: { color: "#eef2f7" },
          },
          x: {
            grid: { display: false },
          },
        },
      }}
    />
  );
};

export default GroupWiseChart;
